import { createFileRoute } from '@tanstack/react-router';

import { CampaignSingleAnalysisPage } from '@/features/campaign-analysis';

export const Route = createFileRoute(
  '/workspace/$workspaceId/campaigns/$campaignId/analysis',
)({
  component: CampaignSingleAnalysisPage,
});
